import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'rebass'
import { Heading } from 'rebass'
import IconArrowDown from '../../vectors/IconArrowDown'
import { bool, string, func } from 'prop-types'

/*************************
 STYLES: Accordion
 **************************/

const Header = styled(({ faq, open, theme, ...rest }) => <Box {...rest} />)`
  color: ${(props) => props.theme.colors.blue};
  font-weight: ${(props) => props.theme.weights[1]};
  border-bottom: 2px
    ${(props) =>
      props.open && props.faq
        ? props.theme.colors.grey_light_op30
        : props.theme.colors.blue}
    solid;
`

const Arrow = styled(IconArrowDown)`
  display: inline-block;
  margin-right: 15px;
  margin-left: 3px;
  top: 50%;
  float: right;
  transform: scale(${(props) => (props.open ? '1.5' : '-1.5')})
    translateY(${(props) => (props.open ? '100%' : '-100%')});
`

const PanelBody = styled(Box)`
  position: relative;
`

const CurrentValue = styled.span`
  color: ${(props) => props.theme.colors.grey_light};
`
CurrentValue.displayName = 'CurrentValue'

const TitleLink = styled(({ faq, theme, ...rest }) => <a {...rest} />)`
  display: block;
  cursor: pointer;
  text-decoration: none;
  color: ${(props) => props.theme.colors.grey_light};
  color: ${(props) =>
    props.faq ? props.theme.colors.blue : props.theme.colors.grey_light};
  width: 100%;
  &:hover {
    color: ${(props) =>
      props.faq ? props.theme.colors.blue : props.theme.colors.grey};
    path {
      fill: ${(props) =>
        props.faq ? props.theme.colors.blue : props.theme.colors.grey};
    }
  }
  &:focus {
    outline: 0;
  }
`
TitleLink.displayName = 'TitleLink'

class ContentAccordion extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isCollapsed: props.collapsed
    }
    this._show = this._show.bind(this)
    this._hide = this._hide.bind(this)
    this._reverseDisplay = this._reverseDisplay.bind(this)
  }

  _show(_e) {
    if (_e) _e.preventDefault()
    this.setState({ isCollapsed: false })
    this.props.onOpen()
  }

  _hide(_e) {
    if (_e) _e.preventDefault()
    this.setState({ isCollapsed: true })
    this.props.onClose()
  }

  _reverseDisplay(_e) {
    if (_e) _e.preventDefault()
    if (this.state.isCollapsed) this._show()
    else this._hide()
  }

  render() {
    // const _isPopulated = (this.props.optionState.length > 0)
    const _tabPanelId = this.props.title.replace(/\s+/g, '').toLowerCase()
    const PanelBodyContent = !this.state.isCollapsed ? (
      <PanelBody
        width={12 / 12}
        py={[0, 20, 30]}
        role="tabpanel"
        id={`tabpanel:${_tabPanelId}`}
      >
        {this.props.children}
      </PanelBody>
    ) : null

    return (
      <Flex flexWrap="wrap" mb={[20, 40, 70]} id={this.props.id}>
        <Header
          width={12 / 12}
          py={18}
          open={this.state.isCollapsed}
          faq={this.props.faq}
        >
          <Heading as="h3" f={[3, null, 5]}>
            <TitleLink
              href="javascript:void(0)"
              onClick={this._reverseDisplay}
              tabIndex="0"
              role="tab"
              aria-controls={`tabpanel:${_tabPanelId}`}
              open={this.state.isCollapsed}
              faq={this.props.faq}
            >
              {this.props.title}
              <Arrow open={this.state.isCollapsed} />
            </TitleLink>
          </Heading>
        </Header>
        {PanelBodyContent}
      </Flex>
    )
  }
}

ContentAccordion.defaultProps = {
  collapsed: true,
  faq: false,
  title: '',
  id: '',
  onOpen: () => {},
  onClose: () => {}
}

ContentAccordion.propTypes = {
  collapsed: bool,
  faq: bool,
  title: string,
  id: string,
  onOpen: func,
  onClose: func
}

export default ContentAccordion
